var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"work-flow-history-activity"},[_c('h1',[_vm._v(_vm._s(_vm.$t('teamTaskDetail.workFlowHistoryActivity')))]),_c('div',{staticClass:"mt-3"},[_c('Timeline',{key:_vm.timeLineKey,attrs:{"items":_vm.timeLineData}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }